const { results_label } = scriptData;

const initPageTitle = () => {
    const resultsShown = document.querySelector('.js-question-form-result');
    if (!resultsShown) {
        return;
    }

    const pageTitle = document.querySelector('.article-h1');
    if (!pageTitle) {
        return;
    }

    pageTitle.textContent = results_label + ' ' + pageTitle.textContent;
};

document.addEventListener('DOMContentLoaded', function () {
    initPageTitle();
});
